module.exports = __webpack_public_path__ + "static/media/metrioptera_brachyptera_006_APA.9933e136.mp3";